import React, { useState, useContext } from 'react';
import { getTranslateByScope } from '../i18n';
import { routes } from '../routes';
import { getCustomers } from '../selectors';
import {
  CenteredWidthAndHeightLayout,
  CenteredBoxSmall,
  SpacingBox,
  PrimaryButton,
  RedParagraph,
  GreenParagraph,
} from '../Components';
import AppContext from '../AppContext';
const translate = getTranslateByScope('app.lowaSelect');



export const LowaCustomerSelect = (({history}) => {
  const context = useContext(AppContext);
  const [customer, setCustomer] = useState();
  const [hasSearched, setHasSearched] = useState();
  const customers = getCustomers(context)
  const customerMap = new Map(customers.map(c => [c.CustomerNo__c, c]));

  function onInput(e) {
    const v = e.target.value;

    if (v.length > 0) {
      setHasSearched(true);
    } else {
      setHasSearched(false);
    }

    const c = customerMap.get(v);

    if (!c || !c.LowaGroup__c) {
      console.log('no lowa group on customer');
      return;
    }
    if (!c) {
      console.log('no results');
      return;
    }
    setCustomer(c);
  }

  function onNext() {
    const c = customer;
    context.actions.setLowaCustomer(c);
          context.actions.setToast({

        title: 'selected',
        text: 'nice!'

      });

    history.push(routes.landingPage);
  }

  const inputStyle = {
    width: '100%'
  }

  return (
    <>
      <CenteredWidthAndHeightLayout>
        <CenteredBoxSmall>
          <SpacingBox>

            <h1>{translate('title')}</h1>
            <p>{translate('desc')}</p>
            <input onChange={onInput} style={inputStyle}/>

            {hasSearched && !customer && (
              <RedParagraph>{translate('invalid')}</RedParagraph>
            )}
            {customer && (
              <>
                <GreenParagraph>{translate('valid')}</GreenParagraph>
                <PrimaryButton onClick={onNext} text="next"/>
              </>
            )}
          </SpacingBox>
        </CenteredBoxSmall>
      </CenteredWidthAndHeightLayout>
    </>
  );
});

export default LowaCustomerSelect;
